import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Intern from '../views/Intern.vue'
import Read from '../views/Read.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/intern',
    name: 'intern',
    component: Intern
  },
  {
    path: '/read',
    name: 'read',
    component: Read
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
